exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a,div,h1,h2,h3,h4,h5,h6,input,label,li,p,span,textarea{font-family:Lato}img{max-width:100%;height:auto}#root{display:flex;min-height:100vh;justify-content:space-between;flex-direction:column}", ""]);

// exports
